/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  FinancialChannelLightResponse,
  FinancialGroupLightResponse,
  FinancialGroupReminderSettings,
  FinancialSummaryResponse,
  HealthProResponse,
  InvoiceResponse,
  InvoiceSearchResponse,
  PatientInvoicesResponse,
  TransactionResponse,
  UpdateTransactionChannelRequest,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    FinancialChannelLightResponseFromJSON,
    FinancialChannelLightResponseToJSON,
    FinancialGroupLightResponseFromJSON,
    FinancialGroupLightResponseToJSON,
    FinancialGroupReminderSettingsFromJSON,
    FinancialGroupReminderSettingsToJSON,
    FinancialSummaryResponseFromJSON,
    FinancialSummaryResponseToJSON,
    HealthProResponseFromJSON,
    HealthProResponseToJSON,
    InvoiceResponseFromJSON,
    InvoiceResponseToJSON,
    InvoiceSearchResponseFromJSON,
    InvoiceSearchResponseToJSON,
    PatientInvoicesResponseFromJSON,
    PatientInvoicesResponseToJSON,
    TransactionResponseFromJSON,
    TransactionResponseToJSON,
    UpdateTransactionChannelRequestFromJSON,
    UpdateTransactionChannelRequestToJSON,
} from '../models/index';

export interface FindFinancialGroupsForBillCreationRequest {
    delegateUuid?: string;
}

export interface GetChannelsByFinancialGroupRequest {
    financialGroupId: number;
    filterByActive?: boolean;
    filterInvoice?: boolean;
}

export interface GetFinancialGroupReminderSettingsRequest {
    financialGroupId: number;
}

export interface GetFinancialSummaryRequest {
    financialGroupId: number;
    startDate?: string;
    endDate?: string;
    healthProId?: string;
    patientId?: string;
    includeImmediatePayments?: boolean;
}

export interface GetHealthProByFinancialGroupRequest {
    financialGroupId: number;
}

export interface GetInvoicesByFinancialGroupRequest {
    financialGroupId: number;
    direction: string;
    financialChannelId?: number;
    startDate?: string;
    endDate?: string;
    healthProId?: string;
    patientId?: string;
    invoiceRef?: string;
}

export interface GetPatientInvoicesRequest {
    patientId: string;
}

export interface SearchInvoicesRequest {
    q: string;
}

export interface UpdateFinancialGroupReminderSettingsRequest {
    financialGroupId: number;
    financialGroupReminderSettings: FinancialGroupReminderSettings;
}

export interface UpdateTransactionChannelOperationRequest {
    transactionId: number;
    updateTransactionChannelRequest: UpdateTransactionChannelRequest;
}

/**
 * 
 */
export class AccountingApi extends runtime.BaseAPI {

    /**
     * Find all financial_group by connected person
     */
    async findFinancialGroupsForBillCreationRaw(requestParameters: FindFinancialGroupsForBillCreationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FinancialGroupLightResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['delegateUuid'] != null) {
            queryParameters['delegateUuid'] = requestParameters['delegateUuid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/financial_group`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FinancialGroupLightResponseFromJSON));
    }

    /**
     * Find all financial_group by connected person
     */
    async findFinancialGroupsForBillCreation(requestParameters: FindFinancialGroupsForBillCreationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FinancialGroupLightResponse>> {
        const response = await this.findFinancialGroupsForBillCreationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get financial channel list for a financial_group
     */
    async getChannelsByFinancialGroupRaw(requestParameters: GetChannelsByFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FinancialChannelLightResponse>>> {
        if (requestParameters['financialGroupId'] == null) {
            throw new runtime.RequiredError(
                'financialGroupId',
                'Required parameter "financialGroupId" was null or undefined when calling getChannelsByFinancialGroup().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterByActive'] != null) {
            queryParameters['filterByActive'] = requestParameters['filterByActive'];
        }

        if (requestParameters['filterInvoice'] != null) {
            queryParameters['filterInvoice'] = requestParameters['filterInvoice'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/financial_group/{financial_group_id}/financial_channel`.replace(`{${"financial_group_id"}}`, encodeURIComponent(String(requestParameters['financialGroupId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FinancialChannelLightResponseFromJSON));
    }

    /**
     * Get financial channel list for a financial_group
     */
    async getChannelsByFinancialGroup(requestParameters: GetChannelsByFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FinancialChannelLightResponse>> {
        const response = await this.getChannelsByFinancialGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get reminder settings for a financial group
     */
    async getFinancialGroupReminderSettingsRaw(requestParameters: GetFinancialGroupReminderSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FinancialGroupReminderSettings>> {
        if (requestParameters['financialGroupId'] == null) {
            throw new runtime.RequiredError(
                'financialGroupId',
                'Required parameter "financialGroupId" was null or undefined when calling getFinancialGroupReminderSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/financial_group/{financial_group_id}/reminder-settings`.replace(`{${"financial_group_id"}}`, encodeURIComponent(String(requestParameters['financialGroupId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FinancialGroupReminderSettingsFromJSON(jsonValue));
    }

    /**
     * Get reminder settings for a financial group
     */
    async getFinancialGroupReminderSettings(requestParameters: GetFinancialGroupReminderSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FinancialGroupReminderSettings> {
        const response = await this.getFinancialGroupReminderSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get financial summary with category breakdowns
     */
    async getFinancialSummaryRaw(requestParameters: GetFinancialSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FinancialSummaryResponse>> {
        if (requestParameters['financialGroupId'] == null) {
            throw new runtime.RequiredError(
                'financialGroupId',
                'Required parameter "financialGroupId" was null or undefined when calling getFinancialSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['end_date'] = requestParameters['endDate'];
        }

        if (requestParameters['healthProId'] != null) {
            queryParameters['health_pro_id'] = requestParameters['healthProId'];
        }

        if (requestParameters['patientId'] != null) {
            queryParameters['patient_id'] = requestParameters['patientId'];
        }

        if (requestParameters['includeImmediatePayments'] != null) {
            queryParameters['includeImmediatePayments'] = requestParameters['includeImmediatePayments'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/financial_group/{financial_group_id}/financial-summary`.replace(`{${"financial_group_id"}}`, encodeURIComponent(String(requestParameters['financialGroupId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FinancialSummaryResponseFromJSON(jsonValue));
    }

    /**
     * Get financial summary with category breakdowns
     */
    async getFinancialSummary(requestParameters: GetFinancialSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FinancialSummaryResponse> {
        const response = await this.getFinancialSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get health list for a financial_group
     */
    async getHealthProByFinancialGroupRaw(requestParameters: GetHealthProByFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HealthProResponse>>> {
        if (requestParameters['financialGroupId'] == null) {
            throw new runtime.RequiredError(
                'financialGroupId',
                'Required parameter "financialGroupId" was null or undefined when calling getHealthProByFinancialGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/financial_group/{financial_group_id}/healthPro`.replace(`{${"financial_group_id"}}`, encodeURIComponent(String(requestParameters['financialGroupId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HealthProResponseFromJSON));
    }

    /**
     * Get health list for a financial_group
     */
    async getHealthProByFinancialGroup(requestParameters: GetHealthProByFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HealthProResponse>> {
        const response = await this.getHealthProByFinancialGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get incomes list for a financial_group
     */
    async getInvoicesByFinancialGroupRaw(requestParameters: GetInvoicesByFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InvoiceResponse>>> {
        if (requestParameters['financialGroupId'] == null) {
            throw new runtime.RequiredError(
                'financialGroupId',
                'Required parameter "financialGroupId" was null or undefined when calling getInvoicesByFinancialGroup().'
            );
        }

        if (requestParameters['direction'] == null) {
            throw new runtime.RequiredError(
                'direction',
                'Required parameter "direction" was null or undefined when calling getInvoicesByFinancialGroup().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['financialChannelId'] != null) {
            queryParameters['financial_channel_id'] = requestParameters['financialChannelId'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['end_date'] = requestParameters['endDate'];
        }

        if (requestParameters['healthProId'] != null) {
            queryParameters['health_pro_id'] = requestParameters['healthProId'];
        }

        if (requestParameters['patientId'] != null) {
            queryParameters['patient_id'] = requestParameters['patientId'];
        }

        if (requestParameters['invoiceRef'] != null) {
            queryParameters['invoice_ref'] = requestParameters['invoiceRef'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/financial_group/{financial_group_id}/invoices`.replace(`{${"financial_group_id"}}`, encodeURIComponent(String(requestParameters['financialGroupId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvoiceResponseFromJSON));
    }

    /**
     * Get incomes list for a financial_group
     */
    async getInvoicesByFinancialGroup(requestParameters: GetInvoicesByFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InvoiceResponse>> {
        const response = await this.getInvoicesByFinancialGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all invoices for a patient
     */
    async getPatientInvoicesRaw(requestParameters: GetPatientInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PatientInvoicesResponse>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientInvoices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/invoices/patient/{patient_id}/invoices`.replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientInvoicesResponseFromJSON(jsonValue));
    }

    /**
     * Get all invoices for a patient
     */
    async getPatientInvoices(requestParameters: GetPatientInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PatientInvoicesResponse> {
        const response = await this.getPatientInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search invoices across all permitted financial groups
     */
    async searchInvoicesRaw(requestParameters: SearchInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoiceSearchResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling searchInvoices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/invoices/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceSearchResponseFromJSON(jsonValue));
    }

    /**
     * Search invoices across all permitted financial groups
     */
    async searchInvoices(requestParameters: SearchInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoiceSearchResponse> {
        const response = await this.searchInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update reminder settings for a financial group
     */
    async updateFinancialGroupReminderSettingsRaw(requestParameters: UpdateFinancialGroupReminderSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FinancialGroupReminderSettings>> {
        if (requestParameters['financialGroupId'] == null) {
            throw new runtime.RequiredError(
                'financialGroupId',
                'Required parameter "financialGroupId" was null or undefined when calling updateFinancialGroupReminderSettings().'
            );
        }

        if (requestParameters['financialGroupReminderSettings'] == null) {
            throw new runtime.RequiredError(
                'financialGroupReminderSettings',
                'Required parameter "financialGroupReminderSettings" was null or undefined when calling updateFinancialGroupReminderSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/financial_group/{financial_group_id}/reminder-settings`.replace(`{${"financial_group_id"}}`, encodeURIComponent(String(requestParameters['financialGroupId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FinancialGroupReminderSettingsToJSON(requestParameters['financialGroupReminderSettings']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FinancialGroupReminderSettingsFromJSON(jsonValue));
    }

    /**
     * Update reminder settings for a financial group
     */
    async updateFinancialGroupReminderSettings(requestParameters: UpdateFinancialGroupReminderSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FinancialGroupReminderSettings> {
        const response = await this.updateFinancialGroupReminderSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the financial channel of a transaction
     */
    async updateTransactionChannelRaw(requestParameters: UpdateTransactionChannelOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransactionResponse>> {
        if (requestParameters['transactionId'] == null) {
            throw new runtime.RequiredError(
                'transactionId',
                'Required parameter "transactionId" was null or undefined when calling updateTransactionChannel().'
            );
        }

        if (requestParameters['updateTransactionChannelRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTransactionChannelRequest',
                'Required parameter "updateTransactionChannelRequest" was null or undefined when calling updateTransactionChannel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/transactions/{transaction_id}/update-channel`.replace(`{${"transaction_id"}}`, encodeURIComponent(String(requestParameters['transactionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTransactionChannelRequestToJSON(requestParameters['updateTransactionChannelRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransactionResponseFromJSON(jsonValue));
    }

    /**
     * Update the financial channel of a transaction
     */
    async updateTransactionChannel(requestParameters: UpdateTransactionChannelOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransactionResponse> {
        const response = await this.updateTransactionChannelRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
